import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const DetailBottomMask = styled.div<React.CSSProperties>`
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    #000 50%,
    #000 78.19%,
    rgba(0, 0, 0, 0) 100%
  );
  position: absolute;
  top: ${Screen.widthRatio * 332}px;
  height: ${Screen.widthRatio * 654}px;
  width: ${Screen.widthRatio * 1920}px;
`;

export default DetailBottomMask;
